/**
 * Badge "in attesa di scansione" (pending-scan): mostrato quando un bundle è stato modificato dopo
 * l'ultima scansione di vulnerabilità (o non è ancora stato scansionato). Stato derivato e
 * auto-risolvente: la prossima scansione lo azzera. Bolla a livello bundle/release/product/lista.
 */
import styles from './Products.module.css';

/** Testo del tooltip, condiviso da tutti i livelli (bundle/release/product). */
export const PENDING_SCAN_TOOLTIP =
  'Il bundle è stato modificato dopo l’ultima scansione di vulnerabilità. ' +
  'Lo stato verrà aggiornato tra pochi minuti, alla prossima scansione.';

export function PendingScanBadge({ testId }: { testId?: string }) {
  return (
    <span
      className={styles.pendingScanBadge}
      title={PENDING_SCAN_TOOLTIP}
      data-testid={testId ?? 'pending-scan-badge'}
    >
      in attesa di scansione
    </span>
  );
}
